import React from 'react'
import {
  AccountsAndPlansPlanDesc,
  AccountsAndPlansPlanDescFirstRow,
  AccountsAndPlansPlanDescSecondRow,
  AccountsAndPlansPlanType,
  AccountsAndPlansProductName,
} from 'Features/accountSettings/routes/AccountSettings/AccountsAndPlans/AccountsAndPlans.styles'
import { useTranslation } from 'react-i18next'

type AccountPlansRowProps = {
  planType: string
  productType: string
  visitsAllowed: number
}

export const AccountPlanDescription = ({
  planType,
  productType,
  visitsAllowed,
}: AccountPlansRowProps) => {
  const { t } = useTranslation('accountSettings')
  return (
    <AccountsAndPlansPlanDesc>
      <AccountsAndPlansPlanDescFirstRow>
        <AccountsAndPlansProductName>
          {t(`reactivation.product_${productType}`)}
        </AccountsAndPlansProductName>
        <AccountsAndPlansPlanType>{t(`reactivation.plan_${planType}`)}</AccountsAndPlansPlanType>
      </AccountsAndPlansPlanDescFirstRow>
      <AccountsAndPlansPlanDescSecondRow>
        {t(`reactivation.up_to`, {
          visits: visitsAllowed,
        })}
      </AccountsAndPlansPlanDescSecondRow>
    </AccountsAndPlansPlanDesc>
  )
}
